import { IOption } from "../../classes/package-listing"
import * as React from 'react';

import Filter from '../../components/filters/filter';
import FixedFilter from '../../components/filters/fixed-filter';

import ClearAll from '../../components/filters/clear-all';


import { FiltersContainerViewProps } from '../../components/filters/container';


const FiltersListView: React.StatelessComponent<FiltersContainerViewProps> = props => {
    return (
        <ul className="ace-filters-list ace-filters-list-centered">
            {props.isFixedPackage ?
                <>
                    {
                        props.text.productionFilterDefaultValue &&
                        <FixedFilter propertyToFilter="productionSeasonId" propertyToDisplay="title" sortFunction={null} filterName={props.text.productionFilterLabel} noSelectionText={props.text.productionFilterDefaultValue} />

                    }
                    {
                        props.text.dayOfWeekFilterDefaultValue &&
                        <FixedFilter propertyToFilter="dayOfWeekString" propertyToDisplay="dayOfWeekString" sortFunction={sortDayOfWeek.bind(this)} filterName={props.text.dayOfWeekFilterLabel} noSelectionText={props.text.dayOfWeekFilterDefaultValue} />
                    }
                    {
                        props.text.timeSlotDefaultValue &&
                        <FixedFilter propertyToFilter="timeSlotString" propertyToDisplay="timeSlotString" sortFunction={null} filterName={props.text.timeSlotFilterLabel} noSelectionText={props.text.timeSlotDefaultValue} />
                    }
                </>
                :
                <>
                    {
                        props.text.productionFilterDefaultValue &&
                        <Filter propertyToFilter="productionSeasonId" propertyToDisplay="title" sortFunction={null} filterName={props.text.productionFilterLabel} noSelectionText={props.text.productionFilterDefaultValue} />
                    }
                    {
                        props.text.dayOfWeekFilterDefaultValue &&
                        <Filter propertyToFilter="dayOfWeekString" propertyToDisplay="dayOfWeekString" sortFunction={sortDayOfWeek.bind(this)} filterName={props.text.dayOfWeekFilterLabel} noSelectionText={props.text.dayOfWeekFilterDefaultValue} />
                    }
                    {
                        props.text.timeSlotDefaultValue &&
                        <Filter propertyToFilter="timeSlotString" propertyToDisplay="timeSlotString" sortFunction={null} filterName={props.text.timeSlotFilterLabel} noSelectionText={props.text.timeSlotDefaultValue} />
                    }
                    </>
            }
            <li className="ace-clear-filters ace-hide-for-medium">
                <ClearAll />
            </li>
        </ul>
    )
}

function sortDayOfWeek(optionA: IOption, optionB: IOption) {
    const dayOfWeekList = ["Weekdays", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

    return dayOfWeekList.indexOf(optionA.value) - dayOfWeekList.indexOf(optionB.value);
}

const FiltersContainerView: React.StatelessComponent<FiltersContainerViewProps> = props => {
    return (
        <>
            <div className="ace-block-inner ace-subs-filter-bar-mobile">
                <button className="btn" type="button">
                    <span id="flexFiltersToggles" className="">
                        <span id="flexFiltersToggleClose" className={`btn-icon-left ${props.filterOpen ? 'show' : 'hide'}`} onClick={props.hideFilters}>
                            <svg className="svg-icon svg-icon-xs" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-close" />' }}></svg>
                            <span className="">Close</span>
                        </span>
                        <span id="flexFiltersToggleOpen" className={`btn-icon-left ${props.filterOpen ? 'hide' : 'show'}`} onClick={props.showFilters}>
                            <svg className="svg-icon" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-filter" />' }}></svg>
                            <span className="">Filter</span>
                        </span>
                    </span>
                </button>
                <div className="ace-clear-filters">
                    <ClearAll />
                </div>
            </div>

            <div className={`ace-filters ${props.filterOpen ? 'ace-subs-filters-open' : 'ace-subs-filters-closed'}`}>
                <FiltersListView {...props}></FiltersListView>
            </div>
        </>
    );
}

export default FiltersContainerView;